import moment from 'moment';

export const fromUtcToLocalTime = (date: Date, format?: string) => {
  const utcDate = moment.utc(date);
  const utcToLocal = moment(utcDate).local().format(format);
  return moment(utcToLocal).toDate();
};
